module.exports = __webpack_public_path__ + "static/media/bu-pl.57c4147b.svg";